import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

import '../debtPayment.scss';

const BitPendingPopupNotificationComponent = (props) => {
  return (
    <div>
      <div className='bit-pending-popup-image'>
        <Image src={require('../images/error.svg')} />
      </div>
      <div className='bit-pending-popup-text'>
        התשלום שלך כבר נמצא בתהליך, אין אפשרות לבחור אמצעי תשלום נוסף. <br /> ניתן להתעדכן בסיומו באפליקציית bit
      </div>

      <BtnSubmit onclick={props.redirectToLobby} text={'חזרה לעמוד הראשי'} />
    </div>
  );
};

export default BitPendingPopupNotificationComponent;
